// Add Stock Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {InventoryItem, AddStockForm} from '../models/inventory.model';
import {AppError, ErrorType} from '../../../Data/config/AppError';
import {LoggerService} from '../../../Services/common/LoggerService';

export class AddStockUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (stockData: AddStockForm): Promise<InventoryItem> {
    try {

      // Business Logic Validation
      if (stockData.quantity <= 0) {
        throw new AppError('الكمية يجب أن تكون أكبر من صفر', ErrorType.VALIDATION);
      }

      if (!stockData.productId || stockData.productId <= 0) {
        throw new AppError('معرف المنتج مطلوب ويجب أن يكون أكبر من صفر', ErrorType.VALIDATION);
      }

      if (stockData.locationId === undefined || stockData.locationId === null) {
        throw new AppError('معرف الموقع مطلوب', ErrorType.VALIDATION);
      }

      // التأكد من أن الموقع هو المستودع الرئيسي (0)
      if (stockData.locationId !== 0) {
        throw new AppError('يجب أن يكون الموقع هو المستودع الرئيسي (0)', ErrorType.VALIDATION);
      }

      if (!stockData.createdBy || stockData.createdBy <= 0) {
        throw new AppError('معرف المستخدم مطلوب ويجب أن يكون أكبر من صفر', ErrorType.VALIDATION);
      }

      const result = await this.inventoryRepository.addStock(stockData);

      return result;
    } catch (error) {
      LoggerService.error('AddStockUseCase error:', error, 'AddStockUseCase');

      // If it's already an AppError, re-throw it
      if (error instanceof AppError) {
        throw error;
      }

      // Convert to AppError for consistency
      throw AppError.fromApiError(error);
    }
  }
}
